<template>
  <Modal :id="id" :title="!!report ? report.name : `Loading...`">
    <div slot="body" class="modal-body">
      <transition name="fade">
        <Alert v-if="hasAlert" :alert="alert" class="text-center" />
      </transition>
      <div class="row">
        <template v-if="report && report.supports_date_range">
          <div class="col-12">
              <p>Leave these date fields blank to run the report based on the default date range for this report.</p>
          </div>
          <div class="col-12">
              <div class="row">
                  <div class="col-6 mb-3">
                      <Field type="datepicker" name="start_date" label="Start Date" v-model="startDate" />
                  </div>
                  <div class="col-6 mb-3">
                      <Field type="datepicker" name="end_date" label="End Date" v-model="endDate" />
                  </div>
              </div>
          </div>
        </template>
        <div class="col-12 mt-3">
          <p>
            Enter the email addresses (one at a time) of the recipients you
            would like to receive this report. Press the ENTER key after
            entering each email to add them to the list of recipients.
          </p>
        </div>
        <div class="col-12">
          <div class="form-group">
            <MultiAssignField
              ref="recipients"
              type="text"
              label="Email Recipients"
              name="recipients"
              v-model="emails"
            />
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="modal-footer">
      <a class="btn btn-info" href="#" @click.prevent="run()">Run Report</a>
      <a class="btn btn-secondary" href="#" @click.prevent="close()">Cancel</a>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
import DisplaysAlerts from "mixins/DisplaysAlerts";
export default {
  mixins: [ModalMixin, DisplaysAlerts],
  data() {
    return {
      id: "manual-report-run-modal",
      report: null,
      emails: [],
      startDate: null,
      endDate: null,
    };
  },
  methods: {
    run() {
      if (this.emails.length === 0) {
        var input = this.$refs.recipients.$refs.input.$refs.input.value;
        if (input.length > 0) {
          this.emails.push(input);
        } else {
          alert(
            "Please enter 1 or more recipient email addresses before continuing."
          );
          return;
        }
      }
      this.axios
        .post(this.route("admin.reports.run", { report: this.report.id }), {
          recipients: this.emails,
          start_date: this.startDate,
          end_date: this.endDate,
        })
        .then(() => {
          this.showAlert(
            "success",
            "Your report has been successfully sent to the recipients below"
          );
        })
        .catch((error) => {
          this.showAlert("danger", error);
        });
    },
  },
  mounted() {
    this.report = this.options.report;
  },
};
</script>

<style lang="scss" scoped>
@import "sass/_variables";
.modal-body {
  background-color: $gray-200;
}
</style>